import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { gql, Apollo } from 'apollo-angular';
import Util from 'src/app/_helpers/util';
import { DataService } from 'src/app/_services/data';
import { SubscriptionCartService } from 'src/app/_services/subscription-cart.service';
import { CompanyService } from 'src/app/_services/company.services';

const loadOfferedFhProduct = gql`
query {
    loadOfferedFhProduct {
        offeredSubscription {
            fhProductId
            fhProductOfferingId
            subscriptionName
            subscriptionPrice
            subscriptionDiscount
            currency
            expiredInDays
            subscriptionFeature {
                featureName
                featureDesc
                featureAvailableQty
            }
        }
        offeredAddOn {
            fhProductId
            fhProductOfferingId
            addOnName
            addOnPrice
            addOnDiscount
            currency
            expiredInDays
            qtyOffered
        }
        offeredVoucher {
            fhProductId
            fhProductOfferingId
            voucherName
            voucherPrice
            voucherDiscount
            currency
            expiredInDays
            creditOffered
        }
    }
}
`;

@Component({
  selector: 'app-subscription-products',
  templateUrl: './subscription-products.component.html',
  styleUrls: ['./subscription-products.component.scss']
})
export class SubscriptionProductsComponent implements OnInit {
  currentlang: any;
  isLoading: boolean = false;
  loadingError: any = null;

  userdata: any;
  usercompany: any;
  isLoggedin: boolean = false;

  // Product data
  offeredSubscription: any[] = [];
  offeredAddOn: any[] = [];
  offeredVoucher: any[] = [];
  
  // Active FH Product subscription
  isSubsribeFhProduct: boolean = false;
  subscriptionInfoPrice: { [key: string]: any } = {};

  // Currency filter
  readonly acceptedCurrency = 'IDR';

  // Cart data
  cartCount: number = 0;
  cartItems: any = {};
  showCartNotification: boolean = false;
  notificationMessage: string = '';
  notificationType: string = 'success'; // success, error, warning

  // Max features for alignment
  maxSubscriptionFeatures: number = 0;
  maxAddonFeatures: number = 0;
  maxVoucherFeatures: number = 0;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private apollo: Apollo,
    private modalService: NgbModal,
    private dataService: DataService,
    private cartService: SubscriptionCartService,
    private companyService: CompanyService
  ) { }

  ngOnInit(): void {
    this.currentlang = localStorage.getItem('language');
    console.log('SubscriptionProductsComponent: ', this.currentlang);
    this.loadProfile();
    this.loadProducts();
    
    // Subscribe to cart changes
    this.cartService.cart$.subscribe((cart: any) => {
      this.cartItems = cart;
      this.cartCount = this.cartService.getCartCount();
      console.log('Cart updated:', cart, 'Total items:', this.cartCount);
    });
  }

  loadProfile() {
    const getuserdata = localStorage.getItem('USERDATA');
    if (getuserdata !== null) {
      this.userdata = JSON.parse(getuserdata);
      console.log('getuserdata', this.userdata);
      this.isLoggedin = true;
    }

    const getusercompany = localStorage.getItem('USERCOMPANY');
    if (getusercompany !== null) {
      this.usercompany = JSON.parse(getusercompany);
      console.log('getusercompany', this.usercompany);
    }
  }

  loadProducts() {
    this.isLoading = true;
    this.loadingError = null;

    this.apollo.query({
      query: loadOfferedFhProduct,
      fetchPolicy: 'no-cache'
    }).subscribe(
      (result: any) => {
        console.log('loadOfferedFhProduct result:', result);
        if (result.data && result.data.loadOfferedFhProduct) {
          const productData = result.data.loadOfferedFhProduct;
          
          // Filter products by accepted currency
          this.offeredSubscription = (productData.offeredSubscription || []).filter(
            (item: any) => item.currency === this.acceptedCurrency
          );
          this.offeredAddOn = (productData.offeredAddOn || []).filter(
            (item: any) => item.currency === this.acceptedCurrency
          );
          this.offeredVoucher = (productData.offeredVoucher || []).filter(
            (item: any) => item.currency === this.acceptedCurrency
          );
          
          // Calculate max features for alignment
          this.maxSubscriptionFeatures = this.calculateMaxFeatures(this.offeredSubscription);
          this.maxAddonFeatures = this.calculateMaxFeatures(this.offeredAddOn, 'addon');
          this.maxVoucherFeatures = this.calculateMaxFeatures(this.offeredVoucher, 'voucher');
          
          console.log('Filtered products by currency:', this.acceptedCurrency);
          
          // Load active subscription info price after loading products
          this.loadActiveSubscriptionInfoPrice();
          
          // Load active FH product after loading products
          this.loadActiveFhProduct();
        }
        this.isLoading = false;
      },
      (error: any) => {
        console.error('Error loading products:', error);
        this.loadingError = error;
        this.isLoading = false;
      }
    );
  }

  loadActiveSubscriptionInfoPrice() {
    console.log("offeredSubscription : ", this.offeredSubscription);
    // Check if there are any offered subscriptions
    if (this.offeredSubscription.length === 0) {
      console.warn('[loadActiveSubscriptionInfoPrice] No offered subscriptions available');
      return;
    }

    this.offeredSubscription.forEach((subscription: any, index: number) => {
      let fhProductOfferingId = subscription.fhProductOfferingId;
      

      let input = {
        fhProductOfferingId: fhProductOfferingId
      };

      this.companyService.getgetActiveSubscriptionInfoPrice(input).subscribe(
        (result: any) => {
          console.log(`[loadActiveSubscriptionInfoPrice] SUCCESS for subscription ${index + 1} (${fhProductOfferingId}) - Received result:`, result);
          
          // With errorPolicy: 'all', errors come through here in result.errors
          if (result.errors && result.errors.length > 0) {
            const errorType = result.errors[0]?.extensions?.type;
            if (errorType === 'CanNotChooseSameSubscription') {
              this.offeredSubscription[index] = { ...this.offeredSubscription[index], isCurrent: true };
            }
            return;
          }

          if (result.data && result.data.getActiveSubscriptionInfoPrice) {

            this.subscriptionInfoPrice[fhProductOfferingId] = result.data.getActiveSubscriptionInfoPrice;

            console.log(' this.subscriptionInfoPrice::: ', this.subscriptionInfoPrice)
          }
        },
        (error: any) => {
          console.error(`[loadActiveSubscriptionInfoPrice] Error details for subscription ${index + 1}:`, {
            message: error.message,
            networkError: error.networkError,
            graphQLErrors: error.graphQLErrors
          });
        }
      );
    });
    console.log('offeredSubscription after processing: ', this.offeredSubscription);
    console.log('[loadActiveSubscriptionInfoPrice] Completed requests for all subscriptions : ',this.subscriptionInfoPrice);
  }

  loadActiveFhProduct() {
    this.companyService.getgetActiveFhProduct().subscribe(
      (result: any) => {     
        if (result.data && result.data.getActiveFhProduct) {
          let activeFhProducts = result?.data?.getActiveFhProduct;
          if (Array.isArray(activeFhProducts) && activeFhProducts.length > 0) {
            this.isSubsribeFhProduct = true;
          } else {
            this.isSubsribeFhProduct = false;
          }
        } else {
          this.isSubsribeFhProduct = false;
        }
      },
      (error: any) => {
        this.isSubsribeFhProduct = false;
      }
    );
  }

  // Add to cart subscription - with toggle functionality
  addToCartSubscription(product: any, type: 'subscription' | 'addon' | 'voucher') {
    // Check if product is already in cart
    if (this.isProductInCart(product.fhProductOfferingId, type)) {
      // Remove from cart if already there
      this.removeFromCart(product.fhProductOfferingId, type);
      return;
    }

    // Validate user is logged in
    if (!this.isLoggedin) {
      this.showNotification(
        'You must be logged in to add items to cart',
        'warning'
      );
      this.router.navigate(['/login']);
      return;
    }

    try {
      const productName = this.getProductName(product, type);
      
      // For subscriptions, only allow one item - clear existing first
      if (type === 'subscription') {
        const existingSubscriptions = this.getCartItemsByType('subscription');
        if (existingSubscriptions.length > 0) {
          // Remove the existing subscription
          existingSubscriptions.forEach(item => {
            this.cartService.removeFromCart(item.fhProductOfferingId, 'subscription');
          });
          
          this.showNotification(
            `Previous subscription has been replaced with ${productName}`,
            'success'
          );
        } else {
          this.showNotification(
            `${productName} has been added to cart!`,
            'success'
          );
        }
      } else {
        // For addons and vouchers, allow multiple items
        this.showNotification(
          `${productName} has been added to cart!`,
          'success'
        );
      }
      
      // Add to cart
      this.cartService.addToCart(product, type, 1);
      
      console.log('Product added to cart:', { product, type });
    } catch (error: any) {
      this.showNotification(
        'Error adding product to cart: ' + (error.message || 'Unknown error'),
        'error'
      );
      console.error('Error adding to cart:', error);
    }
  }

  // Get product name based on type
  private getProductName(product: any, type: string): string {
    switch (type) {
      case 'subscription':
        return product.subscriptionName || 'Subscription';
      case 'addon':
        return product.addOnName || 'Add-on';
      case 'voucher':
        return product.voucherName || 'Voucher';
      default:
        return 'Product';
    }
  }

  // Show notification
  private showNotification(message: string, type: 'success' | 'error' | 'warning' = 'success') {
    this.notificationMessage = message;
    this.notificationType = type;
    this.showCartNotification = true;

    // Auto-hide notification after 4 seconds
    setTimeout(() => {
      this.showCartNotification = false;
    }, 4000);
  }

  // Remove from cart
  removeFromCart(productOfferingId: string, type: string) {
    try {
      this.cartService.removeFromCart(productOfferingId, type);
      this.showNotification('Product removed from cart', 'success');
      console.log('Product removed from cart');
    } catch (error: any) {
      this.showNotification('Error removing product from cart', 'error');
      console.error('Error removing from cart:', error);
    }
  }

  // Get cart count
  getCartCount(): number {
    return this.cartService.getCartCount();
  }

  // Get cart items by type
  getCartItemsByType(type: string): any[] {
    return this.cartService.getItemsByType(type);
  }

  // Get cart total
  getCartTotal(): number {
    return this.cartService.getCartTotal();
  }

  // Check if product is in cart
  isProductInCart(productOfferingId: string, type: string): boolean {
    const items = this.getCartItemsByType(type);
    return items.some(item => item.fhProductOfferingId === productOfferingId);
  }

  switchLang(lang: any) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.currentlang = lang;
  }

  goToCart() {
    if (this.cartCount === 0) {
      this.showNotification('Your cart is empty', 'warning');
      return;
    }
    
    // Navigate to subscription cart page
    console.log('Going to cart...', this.cartItems);
    this.router.navigate(['/subscription-cart']);
  }

  // Get cart summary
  getCartSummary(): any {
    const summary: any = {
      totalItems: this.cartCount,
      totalPrice: this.getCartTotal(),
      itemsByType: {}
    };

    ['subscription', 'addon', 'voucher'].forEach(type => {
      const items = this.getCartItemsByType(type);
      if (items.length > 0) {
        summary.itemsByType[type] = items.length;
      }
    });

    return summary;
  }

  // Calculate maximum number of features in a product list
  calculateMaxFeatures(products: any[], type: string = 'subscription'): number {
    let max = 0;
    
    products.forEach((product: any) => {
      let featureCount = 0;
      if (type === 'subscription' && product.subscriptionFeature) {
        featureCount = product.subscriptionFeature.length;
      } else if (type === 'addon' && product.addOnFeatures) {
        featureCount = product.addOnFeatures.length;
      } else if (type === 'voucher' && product.voucherFeatures) {
        featureCount = product.voucherFeatures.length;
      }
      
      if (featureCount > max) {
        max = featureCount;
      }
    });
    
    return max;
  }

  // Get feature at specific index or return null
  getFeatureAt(features: any[], index: number): any {
    return features && features[index] ? features[index] : null;
  }

  // Generate array for looping
  getFeatureRange(maxFeatures: number): number[] {
    return Array.from({ length: maxFeatures }, (_, i) => i);
  }

  // Get subscription button class based on subscription buying option
  getSubscriptionButtonClass(fhProductOfferingId: string): string {
    if (this.isProductInCart(fhProductOfferingId, 'subscription')) {
      return 'btn-danger';
    }

    if (this.isSubsribeFhProduct && this.subscriptionInfoPrice[fhProductOfferingId]) {
      const option = (this.subscriptionInfoPrice[fhProductOfferingId].subscriptionBuyingOption || '').toLowerCase();
      if (option === 'upgrade') {
        return 'fhbtn3';
      } else if (option === 'downgrade') {
        return 'cdbtn4';
      }
    }

    return 'btn-primary';
  }

  // Get subscription button label based on subscription buying option
  getSubscriptionButtonLabel(fhProductOfferingId: string): string {
    if (!this.isSubsribeFhProduct) {
      return 'subscription_products.add_to_cart';
    }

    const info = this.subscriptionInfoPrice?.[fhProductOfferingId];
    if (!info?.subscriptionBuyingOption) {
      return 'subscription_products.add_to_cart';
    }

    const option = info.subscriptionBuyingOption.toLowerCase();
    if (option === 'upgrade') {
      const amount = (info.priceReductionResult || 0).toLocaleString('id-ID');
      return `Upgrade (IDR ${amount})`;
    } else if (option === 'downgrade') {
      return 'Downgrade (IDR 0)';
    }

    return 'subscription_products.add_to_cart';
  }

  // Get total pro-rate deduction for all upgrade items in cart
  getProRateDeduction(): number {
    let deduction = 0;
    if (!this.isSubsribeFhProduct) return 0;

    this.getCartItemsByType('subscription').forEach((item: any) => {
      const info = this.subscriptionInfoPrice?.[item.fhProductOfferingId];
      if (info && (info.subscriptionBuyingOption || '').toLowerCase() === 'upgrade') {
        deduction += info.priceReductionResult || 0;
      }
    });
    return deduction;
  }

  // Get cart total after pro-rate deduction (no tax)
  getProRatedTotal(): number {
    let total = 0;

    // Subscription items: use pro-rate price from API if user has active subscription
    this.getCartItemsByType('subscription').forEach((item: any) => {
      const info = this.subscriptionInfoPrice?.[item.fhProductOfferingId];
      if (this.isSubsribeFhProduct && info?.subscriptionBuyingOption) {
        const option = info.subscriptionBuyingOption.toLowerCase();
        if (option === 'upgrade') {
          total += info.priceReductionResult || 0;
        } else if (option === 'downgrade') {
          total += 0;
        } else {
          total += ((item.subscriptionPrice || 0) - (item.subscriptionDiscount || 0)) * (item.quantity || 1);
        }
      } else {
        total += ((item.subscriptionPrice || 0) - (item.subscriptionDiscount || 0)) * (item.quantity || 1);
      }
    });

    // Addon and voucher: always use regular price
    this.getCartItemsByType('addon').forEach((item: any) => {
      total += ((item.addOnPrice || 0) - (item.addOnDiscount || 0)) * (item.quantity || 1);
    });
    this.getCartItemsByType('voucher').forEach((item: any) => {
      total += ((item.voucherPrice || 0) - (item.voucherDiscount || 0)) * (item.quantity || 1);
    });

    return total;
  }
}
